
import { NgModule } from '@angular/core';

import { RegistryTypeEditProvider } from './registry-type-edit.provider';
import { RegistryTypeListProvider } from './registry-type-list.provider';

export * from './registry-type-edit.provider';
export * from './registry-type-list.provider';

export {
  RegistryTypeListProvider,
  RegistryTypeEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    RegistryTypeEditProvider,
    RegistryTypeListProvider
  ]
})
export class RegistryTypeBackendModule { }
